import { cloneDeep } from 'lodash'
import { Loader2, Trash2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useNotificationTemplateActions } from './useNotificationTemplateActions'

type Props = {
  template: wowaudit.NotificationTemplate
  onEdit: (template: Partial<wowaudit.NotificationTemplate>) => void
}

const TemplateActionButtons = ({ template, onEdit }: Props) => {
  const {
    triggerTestMessage,
    testMessageLoading,
    triggerDeleteTemplate,
    deleteTemplateLoading,
  } = useNotificationTemplateActions(template)

  return (
    <div className='flex items-center justify-end gap-2'>
      <Button
        type='button'
        size='sm'
        variant='outline'
        disabled={!template.id || testMessageLoading}
        onClick={() => triggerTestMessage()}
      >
        {testMessageLoading ? (
          <span className='flex items-center gap-2'>
            <Loader2 className='w-4 h-4 animate-spin' />
            Sending...
          </span>
        ) : (
          'Send test'
        )}
      </Button>
      <Button
        type='button'
        size='sm'
        variant='secondary'
        onClick={() => onEdit(cloneDeep(template))}
      >
        Edit
      </Button>
      <Button
        type='button'
        size='sm'
        variant='outline'
        className='text-destructive-foreground'
        disabled={!template.id || deleteTemplateLoading}
        onClick={() => triggerDeleteTemplate()}
      >
        <Trash2 className='w-4 h-4' />
      </Button>
    </div>
  )
}

export default TemplateActionButtons
